import {
  Tooltip as ShadCNTooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

type TooltipProps = {
  children: React.ReactNode;
  text: string;
  asChild?: boolean;
};

const Tooltip = ({ children, text, asChild }: TooltipProps) => {
  return (
    <TooltipProvider>
      <ShadCNTooltip>
        <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>
        <TooltipContent side="bottom">
          <p>{text}</p>
        </TooltipContent>
      </ShadCNTooltip>
    </TooltipProvider>
  );
};

export default Tooltip;
